
const zipRx = /^[a-z0-9][a-z0-9\- ]{0,10}[a-z0-9]$/i;
const email = /[^@]+@[^\.]+\..+/i;
export default {
    zipRx,
    email
};
